import Icon from "@ant-design/icons";
import {Image} from "antd";
import {
    ThorIconImg
} from "../../../../assets";


export const MyIcon = (props) => <Image src={ThorIconImg} preview={false}/>
